import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-serif text-2xl text-[#2C221E]">{title}</h2>
    <div className="mt-2 text-base text-[#4A3E39] leading-relaxed">{children}</div>
  </section>
);

export default function TermsPage() {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    api.get("/legal/company").then(({ data }) => setCompany(data.company)).catch(() => {});
  }, []);

  const c = company || { name: "", cif: "", address: "", email: "" };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <div className="flex-1 max-w-2xl w-full mx-auto px-4 py-10 sm:py-16">
        <nav className="mb-8">
          <Link to="/" className="flex items-center gap-2 text-[#C86D51]">
            <Gift className="w-6 h-6" />
            <span className="text-sm font-semibold tracking-wide uppercase">Portwrite</span>
          </Link>
        </nav>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2C221E]" data-testid="terms-title">{t("terms.title")}</h1>

        <Section title={t("terms.provider")}>
          <div data-testid="terms-company">
            <p>{c.name}</p>
            <p>CIF: {c.cif}</p>
            <p>{c.address}</p>
            <p>{t("common.contact")}{" "}
              <a href={`mailto:${c.email}`} className="text-[#B35A3E] hover:underline">{c.email}</a>
            </p>
          </div>
        </Section>

        <Section title={t("terms.serviceTitle")}>
          {t("terms.serviceBodyPre")} <strong>{t("terms.serviceBodyStrong")}</strong> {t("terms.serviceBodyPost")}
        </Section>

        <Section title={t("terms.priceTitle")}>
          {t("terms.priceBody")}
        </Section>

        <Section title={t("terms.deliveryTitle")}>
          {t("terms.deliveryPre")} <strong>{t("terms.deliveryStrong")}</strong> {t("terms.deliveryPost")}
        </Section>

        <Section title={t("terms.withdrawalTitle")}>
          {t("terms.withdrawalPre")} <strong>{t("terms.withdrawalStrong")}</strong> {t("terms.withdrawalPost")}
        </Section>

        <Section title={t("terms.liabilityTitle")}>
          {t("terms.liabilityBody")}
        </Section>

        <Section title={t("terms.lawTitle")}>
          {t("terms.lawPre")}{" "}
          <a href={`mailto:${c.email}`} className="text-[#B35A3E] hover:underline">{c.email}</a>.
        </Section>
      </div>
      <Footer />
    </div>
  );
}
